import { render, staticRenderFns } from "./IconConstructionWorker.vue?vue&type=template&id=b43e4e10&scoped=true&"
import script from "./IconConstructionWorker.vue?vue&type=script&lang=js&"
export * from "./IconConstructionWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43e4e10",
  null
  
)

export default component.exports